export const FILTER_MENU = [
  {
    text: 'По количеству программ',
    value: 'events_count',
  },
  {
    text: 'По количеству компетенций',
    value: 'competences_count',
  },
];

export const DEFAULT_SORT = 'events_count';

export const LIMITS = ['12', '24', '36'];
export const PAGE_SIZE = LIMITS[1];
export const PAGE_NUMBER = 1;

export const STORE_MODULE_NAME = 'professionsList';
export const FETCH_ITEMS = 'fetchItems';
export const SET_ITEMS = 'setItems';
export const SET_COUNT = 'setCount';



// WEBPACK FOOTER //
// ./src/pages/professions/list/consts.ts